import * as React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'

import { SubTabs, SubTab } from 'components/layout'
import { Activity } from 'containers/forms/activities'
import { ACTIVITY_SECTIONS, ORGANIZATION_MODES } from 'constants/enums'

class AwardActivityTab extends React.PureComponent {
  static propTypes = {
    actId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    intlKey: PropTypes.string.isRequired,
    awardProps: PropTypes.object.isRequired,
    activityProps: PropTypes.object.isRequired,
    isAssessorDetailMandatory: PropTypes.object.isRequired,
    isAssessorWelcomeEmailEnabled: PropTypes.bool.isRequired,
    isMessagingEnabled: PropTypes.bool.isRequired,
    isBadgesEnabled: PropTypes.bool.isRequired,
    isBadgesStrictModeEnabled: PropTypes.bool.isRequired
  }

  renderActivity = ({
    activity = {},
    formPrefix = '',
    isMultiple,
    sectionState = {}
  }) => {
    const {
      activityProps: {
        route,
        activities,
        awards,
        approveActivity,
        returnActivity,
        signoffActivity,
        returnSignoffActivity,
        updateActivity,
        changeActivityAssessor,
        setupActivity,
        changeActivityState,
        onRestoreActivity
      },
      isAssessorDetailMandatory,
      isAssessorWelcomeEmailEnabled,
      isMessagingEnabled,
      isBadgesEnabled,
      isBadgesStrictModeEnabled
    } = this.props

    const award = awards.list[0] || {}
    const isOffline =
      get(award, 'awardMode.value') === ORGANIZATION_MODES.offline.id
    const orgId = get(award, 'organization.id')

    return (
      <Activity
        key={`${formPrefix}-${award.id}-${activity.id}`}
        form={`${formPrefix}-${award.id}-${activity.id}`}
        sectionState={sectionState}
        route={route}
        activities={activities}
        data={activity}
        awardValidations={get(award, 'validations')}
        isMultiple={isMultiple}
        approveActivity={approveActivity}
        returnActivity={returnActivity}
        signoffActivity={signoffActivity}
        returnSignoffActivity={returnSignoffActivity}
        onRestoreActivity={() => onRestoreActivity(activity.id)}
        updateActivity={updateActivity}
        changeActivityAssessor={changeActivityAssessor}
        setupActivity={setupActivity}
        changeActivityState={changeActivityState}
        isParentLoading={awards.loading}
        isOffline={isOffline}
        awardState={award.awardState}
        award={award}
        orgId={orgId}
        isAssessorDetailMandatory={isAssessorDetailMandatory}
        isAssessorWelcomeEmailEnabled={isAssessorWelcomeEmailEnabled}
        isMessagingEnabled={isMessagingEnabled}
        isBadgesEnabled={isBadgesEnabled}
        isBadgesStrictModeEnabled={isBadgesStrictModeEnabled}
      />
    )
  }

  render() {
    const { actId, title, intlKey, awardProps } = this.props

    const { activityData, award, onTabChange, onSubTabChanged } = awardProps

    const isMultiple = activityData[ACTIVITY_SECTIONS[actId].id].length > 1

    const isSingle = activityData[ACTIVITY_SECTIONS[actId].id].length === 1

    let sectionState = {}

    switch (actId) {
      case 'physical':
        sectionState = award.physRecSectionState
        break
      case 'skills':
        sectionState = award.skillsSectionState
        break
      case 'service':
        sectionState = award.serviceSectionState
        break
      default:
    }

    return (
      <SubTab title={title} intlKey={intlKey} onChange={onTabChange}>
        {isMultiple &&
          <SubTabs equalWidth onChange={onSubTabChanged} id="activities">
            {activityData[ACTIVITY_SECTIONS[actId].id].map(activity => {
              const actState = get(activity, 'activityState')

              /* const isDeleted =
                get(actState, 'value') === PROGRESS_STATES.activityDeleted.id */

              return (
                <SubTab
                  key={activity.id}
                  title={get(
                    activity,
                    'activityCategory.translatedName',
                    'Unknown Category'
                  )}
                  onChange={onSubTabChanged}
                >
                  {this.renderActivity({
                    activity,
                    formPrefix: `${actId}ActivityForm`,
                    isMultiple: true,
                    sectionState: actState
                  })}
                </SubTab>
              )
            })}
          </SubTabs>}
        {isSingle &&
          this.renderActivity({
            activity: activityData[ACTIVITY_SECTIONS[actId].id][0],
            formPrefix: `${actId}ActivityForm`,
            isMultiple: false,
            sectionState
          })}

        {!isSingle &&
          !isMultiple &&
          <FormattedMessage
            id="label.no_activities"
            defaultMessage="No Activities"
          />}
      </SubTab>
    )
  }
}

export default AwardActivityTab
